import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  CardAction,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

type DetailPaneHeaderProps = {
  title: string;
  onClose: () => void;
};

export const DetailPaneHeader = (props: DetailPaneHeaderProps) => {
  const { title, onClose } = props;
  const { t } = useTranslation();

  return (
    <CardHeader className="gap-2 border-b p-4 [.border-b]:pb-4">
      <CardTitle className="text-xl">{title}</CardTitle>
      <CardDescription className="sr-only">{title}</CardDescription>
      <CardAction>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={t('Close')}
          onClick={onClose}
        >
          <X className="size-4" />
        </Button>
      </CardAction>
    </CardHeader>
  );
};
